import { Card, CardProps, useMediaQuery, useTheme } from "@mui/material";

export const StyledReportCardRoot: React.FC<CardProps> = ({ children, sx, ...rest }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        maxWidth: 400,
        minWidth: isMobile ? "unset" : 400,
        marginRight: "10px",
        marginBottom: "10px",
        ...sx
      }}
      {...rest}
    >
      {children}
    </Card>
  );
};
